import React, { useState } from 'react';
import TopSection from '../LT/TopSection';
import {
    Box,
    Tab,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AdoptionMetricsPBI from './AdoptionMetricsPBI';
import LTPerformanceMetricsPBI from './LTPerformanceMetricsPBI';

const KPIScreens = () => {
    const [tabValue, setTabValue] = useState("Adoption_Metrics")
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    return (
        <div>
            <div>
                <TopSection
                    labelList={[
                        { title: "Home", path: "/landing-page" },
                        { title: "KPI Tracking" },
                    ]}
                    // tabTitle="KPI Tracking"
                />
            </div>
            <div style={{marginTop:-30}}>
                <TabContext value={tabValue} >
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                            onChange={handleTabChange}
                            aria-label="lab API tabs example"
                            sx={{
                                "& .Mui-selected": {
                                    backgroundColor: "#aaaaaa",
                                    color: "#000 !important",
                                    borderRadius: "10px",
                                },
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                            }}
                        >
                            <Tab
                                label="Adoption Metrics"
                                value="Adoption_Metrics"
                                sx={{
                                    width: "50%",
                                    fontSize: "13px",
                                    minHeight: "40px !important",
                                    maxWidth: "700px",
                                }}
                            />
                            <Tab
                                label="LT Performance Metrics"
                                value="LT_Performance_Metrics"
                                sx={{
                                    width: "50%",
                                    fontSize: "13px",
                                    minHeight: "40px !important",
                                    maxWidth: "700px",
                                }}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value="Adoption_Metrics" style={{ padding: "5px 0px" }}>
                        <AdoptionMetricsPBI/>
                    </TabPanel>
                    <TabPanel value="LT_Performance_Metrics" style={{ padding: "5px 0px" }}>
                        <LTPerformanceMetricsPBI />
                    </TabPanel>
                </TabContext>
            </div>
        </div>
    )
}

export default KPIScreens;